// src/js/config/performSave.js

import { DOMElements } from './dom.js';
import { CONFIG_KEY_PREFIX } from './constants.js';
import { populateConfigSelect } from './ui/populateConfigSelect.js';
import { showMessage } from './ui/showMessage.js';

/**
 * Utför den faktiska sparningen av en konfiguration till Local Storage och uppdaterar UI.
 * @param {Object} configDataToSave - Det kompletta konfigurationsobjektet.
 * @param {Function} [onSuccessCallback] - En valfri funktion som körs efter en lyckad sparning.
 */
export function performSave(configDataToSave, onSuccessCallback) {
    const { configNameInput } = DOMElements;
    const strings = window.SimP_Strings || {};

    try {
        const configId = configDataToSave.name;
        localStorage.setItem(CONFIG_KEY_PREFIX + configId, JSON.stringify(configDataToSave));

        populateConfigSelect(); // Uppdatera dropdown

        showMessage((strings.save_success || 'Konfigurationen "%s" har sparats.').replace('%s', configDataToSave.name), 'success');

        if (configNameInput) {
            configNameInput.value = configDataToSave.name;
        }

        if (typeof onSuccessCallback === 'function') {
            onSuccessCallback();
        }
    } catch (error) {
        console.error("Fel vid sparning till Local Storage:", error);
        showMessage((strings.save_error || "Kunde inte spara: ") + error.message, 'error');
    }
}